import styled from 'styled-components';

export const Container = styled.nav`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.espaco.xs};
  width: 100%;
`;

export const Titulo = styled.h2`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.espaco.sm};
  padding: 0 ${({ theme }) => theme.espaco.md} ${({ theme }) => theme.espaco.xs};
  color: ${({ theme }) => theme.cores.inkInverseMuted};
  font-size: ${({ theme }) => theme.fonte.caption};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const ButtonAtalho = styled.button<{ $ativo?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.espaco.md};
  width: 100%;
  min-height: 40px;
  padding: 0 ${({ theme }) => theme.espaco.md};
  border: none;
  border-radius: ${({ theme }) => theme.raio.md};
  background-color: ${({ $ativo, theme }) => ($ativo ? theme.cores.primarySoft : 'transparent')};
  box-shadow: ${({ $ativo, theme }) => ($ativo ? `inset 3px 0 0 ${theme.cores.accent}` : 'none')};
  color: ${({ $ativo, theme }) => ($ativo ? theme.cores.accent : theme.cores.inkInverse)};
  font-weight: 500;
  text-align: left;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: ${({ theme }) => theme.cores.primarySoft};
  }
`;

export const Label = styled.span`
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
